import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import config from "../services/config.json";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as yup from "yup";
import SubmitButton from '../components/SubmitButton';
import { IoEyeOutline } from 'react-icons/io5';
import usePost from '../customHooks/usePost';
import { toast } from 'react-toastify';
import { getTokenSession, setTokenSession } from '../utils/common';

const LogInPage = () => {
  const navigate = useNavigate();
  const [res, apiMethod] = usePost()

  useEffect(() => {
    if (getTokenSession()) {
      navigate(`/${config.demo}`)
    }
  }, [navigate])
  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = yup.object({
    email: yup.string().email("Invalid Email").required("Required"),
    password: yup.string().min(8, "Minimum 8 characters").max(20, "Maximum 20 characters").required("Required")
  });


  const handleSubmit = (values) => {
    let formdata = new FormData();
    for (const item in values) {
      formdata.append(item, values[item])
    }
    apiMethod("login", formdata)
  };
  useEffect(() => {
    if (res.data) {
      const { status, message, data } = res?.data
      if (status === false) {
        toast.error(message);
      }
      else {
        toast.success(message);
        setTokenSession(data?.api_token)
        navigate("/");
      }
    }
  }, [res.data])


  const ref = useRef(null);
  const [showPassword, setShowPassword] = useState(false);

  const hidePass = () => {
    if (ref.current) {
      ref.current.type = "password";
      setShowPassword(false);
    }
  };

  const showPass = () => {
    if (ref.current) {
      ref.current.type = "text";
      setShowPassword(true);
    }
  };

  return (
    <div className='loginPage h-svh overflow-hidden items-center gap-14'>
      <div className="loginPage__left h-svh  relative">
        <div className="loginPage__left- w-[37.375rem] h-[37.375rem] bg-secondary opacity-[.6] blur-[247px] absolute left-[-50%] top-[-50%]"></div>
        <div className='loginPage__leftBox  overflow-hidden relative h-full'>
          <div className="absolute inset-0 bg-[#A38560]/30 backdrop-blur-[5px]"></div>
          <img src="/webImages/loginImage.png" className='w-full h-full  object-cover' alt="login" />
          {/* <div className="loginPage__leftBox-txt left-0 right-0 mx-auto w-[80%] leading-[1] absolute top-[50%] transform translate-y-[-50%] text-center text-white">
            <h1 className='m-0 font-MluvkaLight text-[5.125rem] uppercase'>Book Your <b>Car</b></h1>
          </div> */}

          <div className="loginPage__Right bg-black/20 backdrop-blur-xl border border-white/20 rounded-2xl shadow-2xl p-8 max-[1024px]:p-4 text-white left-0 right-0 mx-auto w-fit max-[1024px]:w-[95%] absolute top-[50%] transform translate-y-[-50%]">
            <div className='loginPage__Rightt w-full mx-auto'>
              <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} validateOnChange>
                <Form>
                  <div className='logo mb-6'>
                    <Link to={`/${config.demo}`}>
                      <img src="/webImages/logo.png" className='w-[15rem] mx-auto' alt="logo.png" />
                    </Link>
                  </div>
                  <div className='inputBox mb-4'>
                    <label htmlFor="" className='capitalize font-Cinzel text-[1rem]'>Email address</label>
                    <Field name="email" type="text" className='border text-black border-[#D9D9D9] h-[2.8rem] outline-none rounded-full w-full px-4' placeholder='email address' />
                    <div className='my-1'>
                      <ErrorMessage name="email">
                        {(msg) => (
                          <div style={{ color: "red", whiteSpace: "nowrap" }}>
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className='inputBox'>
                    <label htmlFor="" className='capitalize font-Cinzel'>Password</label>
                    <div className='relative'>
                      <Field innerRef={ref} name="password" type="password" className='border text-black border-[#D9D9D9] h-[2.8rem] outline-none rounded-full w-full px-4' placeholder='Password' />
                      <span className="absolute top-[50%] transform translate-y-[-50%] right-[1rem]">
                        <IoEyeOutline className="text-[1.2rem] cursor-pointer" color={"#cdcdcd"} onClick={() => !showPassword ? showPass() : hidePass()} />
                      </span>
                    </div>
                    <div className='my-1'>
                      <ErrorMessage name="password">
                        {(msg) => (
                          <div style={{ color: "red", whiteSpace: "nowrap" }}>
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </div>
                  </div>
                  {/* <Link className='forget w-full block text-right hover:text-secondary transition-all duration-300'>Forgot Password</Link> */}
                  <SubmitButton
                    props={{
                      class:
                        // base look
                        "text-white px-24 uppercase py-3 rounded-full w-full block mt-5 submit " +
                        "focus:ring-4 focus:outline-none focus:ring-[#A38560]/50 dark:focus:ring-[#1B3121]/60 " +
                        // smooth animation
                        "transition-[background-position] duration-700 ease-in-out " +
                        // wide gradient that slides on hover
                        "bg-[linear-gradient(45deg,#1B3121,#A38560)] [background-size:200%_100%] " +
                        "[background-position:0%_50%] hover:[background-position:50%_0%]",
                      text: "Sign In",
                    }}
                    buttonLoading={res.isLoading}
                  />
                </Form>
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogInPage;
